import { ApiError } from '@estee/elc-http-transport/typings/elc-http-transport/src/HttpTransport';
import * as Sentry from '@sentry/react';

import { PrimitiveValueType } from '~domain/entities/Config';

const piiDataFields = [
    'phone1',
    'phone2',
    'mobileNumber',
    'pcEmailAddress',
    'emailAddress',
    'birthYear',
    'birthMonth',
    'birthDay',
    'firstName',
    'lastName',
    'fullName',
    'firstNameAlternate',
    'lastNameAlternate',
    'password'
];
const maskField = (value: PrimitiveValueType | undefined) => {
    const len = value?.toString()?.length;

    return len ? '*'.repeat(len) : value;
};

const maskData = (data: { [key: string]: PrimitiveValueType | undefined }) => {
    const result = JSON.parse(JSON.stringify(data));

    piiDataFields.forEach((field) => {
        if (data.hasOwnProperty(field)) {
            result[field] = maskField(data[field]);
        }
    });

    return result;
};

// HttpTransport error response
const isElcApiError = (error: Error): error is ApiError => {
    return error.hasOwnProperty('errorResponse');
};

export const tryGetApiError = (error: Error): { key: string; message: string } | undefined => {
    if (isElcApiError(error)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (error.errorResponse as any)?.data?.errors?.[0];
    }

    return undefined;
};

export const captureException = (
    e: Error,
    options?: {
        extra?: Record<string, PrimitiveValueType | undefined>;
        exclude?(
            errorCode: string,
            options?: { statusCode?: number; errorMessage?: string }
        ): boolean;
    }
) => {
    const { extra = {}, exclude } = options || {};
    const apiError = tryGetApiError(e) || {
        key: '',
        message: ''
    };
    const statusCode = isElcApiError(e) ? e.status : undefined;
    const isExcluded =
        exclude && exclude(apiError.key, { statusCode, errorMessage: apiError.message });

    const isApiError = isElcApiError(e);
    const error = isApiError ? new Error(`API error: ${e.message} ${apiError.key}`) : e;

    if (!isExcluded) {
        Sentry.captureException(error, {
            extra: {
                extra: maskData(extra),
                error: isApiError ? { ...apiError } : { message: e.message, stack: e.stack }
            }
        });
    }

    return !isExcluded;
};
